module.exports = __webpack_public_path__ + "static/media/registar_venda.c07b6c9d.svg";